function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckbox2N20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 952 copy",
  style: {
    fill: "#fff",
    stroke: "#ddd"
  }
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h20v20H0z",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h19v19H.5z",
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m-15855.888 1245.293-.042.042-4.772-4.773 1.063-1.063 3.759 3.761 6.758-6.759 1.06 1.059-7.778 7.778z",
  "data-name": "Union 64",
  style: {
    fill: "#eaeaea"
  },
  transform: "translate(15864.402 -1231.001)"
}));
export default SvgIconCheckbox2N20;